/**
 * 采用正则格式化日期
 * @param fmt 正则格式 例如 yyyy-MM-dd hh:mm:ss
 * @param value 日期字符串或时间戳
 * @returns {*}
 */
function dateFormat(fmt, value) {
    let date;
    if(value === null || value=== undefined || value === ""){
       date = new Date();
    }else{
        switch (typeof (value)) {
            //时间戳
            case 'number':
                date = new Date(value);
                break;
            case 'string':
                //兼容IE  2019-06-22T09:55:02.000+0800 >> 2019/06/22 09:55:02
                if (value.indexOf('T') !== -1 && value.indexOf('+') !== -1) value = value.replace(/-/g, '/').replace('T', ' ').substring(0, value.indexOf('.'))
                date = new Date(value.replace(/-/g, '/').replace('T', ' '));
                break;
            default:
                break;
        }
    }
    let ret;
    let opt = {
        "y+": date.getFullYear().toString(),        // 年
        "M+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "h+": date.getHours().toString(),           // 时
        "m+": date.getMinutes().toString(),         // 分
        "s+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        let reg = new RegExp("(" + k + ")");
        ret = reg.exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        }
    }
    return fmt;
}

/**
 * 判断浏览器类型
 * @returns {string} 浏览器名称
 */
 function getBrowserName(){
    if(!navigator || !window) return
    let userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    let isOpera = userAgent.indexOf('Opera') > -1;
    //判断是否Opera浏览器
    if (isOpera) { return 'Opera' }
    //判断是否Firefox浏览器
    if (userAgent.indexOf('Firefox') > -1) { return 'Firefox' }
    //判断是否Chrome浏览器
    if (userAgent.indexOf('Chrome') > -1) { return 'Chrome' }
    //判断是否Safari浏览器
    if (userAgent.indexOf('Safari') > -1) { return 'Safari' }
    //判断是否IE浏览器
    if (!!window.ActiveXObject || 'ActiveXObject' in window) { return 'IE' }
}

/**
 * 切割前n个字符串
 * @param value 字符串全量
 * @param max 最大切割量
 * @returns {string}  切割后的字符串
 */
function cut(value, max) {
    if (!value) return '';
    if (typeof value !== 'string') return
    max = parseInt(max, 10);
    if (!max) {
        return value;
    }
    if (value.length <= max) return value;
    value = value.substr(0, max);
    return value + (' …');
}

export const utils = {
    dateFormat:dateFormat,
    getBrowserName:getBrowserName,
    cutString:cut
}
